module.exports = __webpack_public_path__ + "static/debate-club-fd4237b078ab80d444cec6162631e471.png";